'use client';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import etLocale from '@fullcalendar/core/locales/et';
import enLocale from '@fullcalendar/core/locales/en-gb';

export type Event = {
  id: string;
  title: string;
  start: Date;
  end: Date;
};

export default function CalendarView(props: { events: Event[]; locale: string }) {
  return (
    <FullCalendar
      plugins={[dayGridPlugin]}
      initialView="dayGridMonth"
      events={props.events}
      locale={props.locale == 'et' ? etLocale : enLocale}
      eventTimeFormat={{
        hour: '2-digit',
        minute: '2-digit',
      }}
      displayEventEnd
      eventBackgroundColor='#f97315'
      eventBorderColor='#f97315'
    />
  );
}
